<template>
  <div class="news-count-card" @click="onCardClick(title)">
    <div class="news-count">
      <div class="news-count-title">
        <div class="count-title">{{title}}</div>
        <div class="unit">单位: 条</div>
      </div>
      <div class="news-detail-count">
        <div class="count">{{count}}</div>
      </div>
    </div>
    <div class="chart-title">
      近30天走势
    </div>
    <div class="chart">
      <HomeHeaderNewsLineChart :data="trendData" :color="color" :color1="color1" v-if="trendData"></HomeHeaderNewsLineChart>
    </div>
  </div>
</template>

<script>
import HomeHeaderNewsLineChart from '@/components/news-monitor/HomeHeaderNewsLineChart';

export default {
  props: {
    title: {
      type: String
    },
    count: {
      type: Number
    },
    trendData: {
      type: Object,
      default: null
    },
    color: {
      type: String
    },
    color1: {
      type: String
    }
  },
  methods: {
    onCardClick() {
      this.$emit('onCardClick', this.title);
    }
  },
  components: {
    HomeHeaderNewsLineChart
  }
};
</script>

<style lang="scss" scoped>
.news-count-card {
  position: relative;
  .chart-title {
    position: absolute;
    bottom: 12px;
    left: 24px;
    color: rgba(255, 255, 255, 0.5);
    font-size: 12px;
    z-index: 1;
  }
  .news-count {
    display: flex;
    justify-content: space-between;
    height: 52px;
    padding: 16px 24px 0;
    background-color: #3e3c42;
    font-size: 14px;
    .count-title{
      color: rgba(255, 255, 255, 0.8);
    }
    .unit {
      color: rgba(255, 255, 255, 0.6);
      font-size: 12px;
    }
    .count {
      color: #ffffff;
      font-size: 32px;
    }
  }
  .chart {
    width: 100%;
    height: 76px;
    background-color: #3e3c42;
  }
}
</style>

